import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import HamburgerMenu from './HamburgerMenu';
import '../styles/tab-navigation.css';
import '../styles/components/MinimalHeader.css';

/**
 * MinimalHeader - グローバルヘッダーコンポーネント
 *
 * @param {React.ReactNode} actionButton - 右側のアクションボタン（任意）
 * @param {boolean} showMenu - メニューボタンを表示するか（デフォルト: true）
 */
const MinimalHeader = ({
  actionButton = null,
  showMenu = true
}) => {
  const navigate = useNavigate();
  const { logout, isAuthenticated } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const authenticatedItems = [
    { icon: 'fas fa-user', label: 'マイページ', onClick: () => { navigate('/mypage'); closeMenu(); } },
    { icon: 'fas fa-cog', label: 'プロフィール編集', onClick: () => { navigate('/profile/edit'); closeMenu(); } },
    { icon: 'fas fa-gem', label: 'プラン変更', onClick: () => { navigate('/plans'); closeMenu(); } },
    { icon: 'fas fa-clipboard-list', label: '相談履歴', onClick: () => { navigate('/consultation-history'); closeMenu(); } },
    { icon: 'fas fa-book-open', label: '保存レシピ', onClick: () => { navigate('/recipes'); closeMenu(); } },
    { icon: 'fas fa-question-circle', label: 'FAQ', onClick: () => { navigate('/faq'); closeMenu(); } },
    { icon: 'fas fa-book', label: '使い方ガイド', onClick: () => { navigate('/how-to-use'); closeMenu(); } },
    { icon: 'fas fa-file-alt', label: '利用規約', onClick: () => { navigate('/terms'); closeMenu(); } },
    { icon: 'fas fa-lock', label: 'プライバシーポリシー', onClick: () => { navigate('/privacy'); closeMenu(); } },
    { icon: 'fas fa-balance-scale', label: '特定商取引法', onClick: () => { navigate('/commercial-law'); closeMenu(); } },
    { icon: 'fas fa-sign-out-alt', label: 'ログアウト', onClick: () => { logout(); closeMenu(); navigate('/'); } },
  ];

  const unauthenticatedItems = [
    { icon: 'fas fa-sign-in-alt', label: 'ログイン', onClick: () => { navigate('/login'); closeMenu(); } },
    { icon: 'fas fa-user-plus', label: '新規登録', onClick: () => { navigate('/register'); closeMenu(); } },
    { icon: 'fas fa-question-circle', label: 'FAQ', onClick: () => { navigate('/faq'); closeMenu(); } },
    { icon: 'fas fa-book', label: '使い方ガイド', onClick: () => { navigate('/how-to-use'); closeMenu(); } },
    { icon: 'fas fa-file-alt', label: '利用規約', onClick: () => { navigate('/terms'); closeMenu(); } },
    { icon: 'fas fa-lock', label: 'プライバシーポリシー', onClick: () => { navigate('/privacy'); closeMenu(); } },
    { icon: 'fas fa-balance-scale', label: '特定商取引法', onClick: () => { navigate('/commercial-law'); closeMenu(); } },
  ];

  const menuItems = isAuthenticated ? authenticatedItems : unauthenticatedItems;
  const dividers = isAuthenticated ? [6, 9] : [3];

  return (
    <>
      <header className="minimal-header">
        <div className="minimal-header__logo" onClick={() => navigate('/')}>
          <span className="minimal-header__logo-icon">
            <img src="/tsumugi2.png" alt="つむぎ" className="minimal-header__logo-img" />
          </span>
          <div className="minimal-header__logo-text-group">
            <span className="minimal-header__logo-main">はしもと栄養</span>
            <span className="minimal-header__logo-sub">パートナー</span>
          </div>
        </div>

        <div className="minimal-header__actions">
          {actionButton}
          {showMenu && (
            <button
              className="minimal-header__menu"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="メニュー"
            >
              ☰
            </button>
          )}
        </div>
      </header>

      <HamburgerMenu
        isOpen={menuOpen}
        onClose={closeMenu}
        menuItems={menuItems}
        showDividerAfter={dividers}
      />
    </>
  );
};

export default MinimalHeader;
